export default __webpack_public_path__ + "static/puerto-salgar-5c25c4d5785cb47a506877a99d2ad01d.png";